import { useMutation } from 'react-query';

import { duplicatePoapView as mutationFn } from 'api/endPoints/duplicatePoapView';

export const useMutationDuplicatePoapView = () => {
    return useMutation<DuplicatePoapViewResponse, QueryError, QueryParams>({
        mutationFn: (params) => mutationFn(params),
    });
};

export interface DuplicatePoapViewResponse {
    viewId: number;
    viewName?: string;
}

export interface QueryParams {
    viewId: number;
    viewName: string;
}
